import { render, staticRenderFns } from "./NotificationTimeSince.vue?vue&type=template&id=ed36c6e6"
import script from "./NotificationTimeSince.vue?vue&type=script&lang=js"
export * from "./NotificationTimeSince.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports